
import Vue from 'vue';
import { TransformedTmStandard } from '~/transforms/transformModules';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => TransformedTmStandard['data'],
      required: true,
    },
  },
});
